export const restSymbology = {
  data() {
    return {
      symbologies: []
    }
  },
  methods: {
    //Mensaje de error del backend, con guarda: un error de red no trae `response`.
    symbologyError: function (error) {
      console.log(error)
      return error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : 'No fue posible comunicarse con el servidor.'
    },
    getSymbologies: function () {
      var that = this;
      return this.$http.get(this.$store.getters.backendurl + 'api/v1/layers/' + this.$route.params.idLayer + '/symbologies')
        .then(function (response) {
          that.symbologies = response.data || [];
        })
        .catch(function (error) {
          that.message = that.symbologyError(error);
        });
    },
    //post/put/delete devuelven la promesa: la vista encadena el refresco del listado.
    postSymbology: function (body) {
      return this.$http.post(this.$store.getters.backendurl + 'api/v1/layers/' + this.$route.params.idLayer + '/symbologies', body)
    },
    putSymbology: function (idSymbology, body) {
      return this.$http.put(this.$store.getters.backendurl + 'api/v1/layers/' + this.$route.params.idLayer + '/symbologies/' + idSymbology, body)
    },
    deleteSymbology: function (idSymbology) {
      return this.$http.delete(this.$store.getters.backendurl + 'api/v1/layers/' + this.$route.params.idLayer + '/symbologies/' + idSymbology)
    },
    //Una sola petición para todas las capas ArcGIS del mapa: el dropdown de
    //ListPlegable no puede disparar una petición por fila.
    loadSymbologiesForLayers: function () {
      var ids = (this.$store.getters.getLayers || [])
        .reduce(function (acc, category) { return acc.concat(category.layers || []) }, [])
        .filter(function (layer) { return layer.provider && layer.provider.name === 'arcgis' })
        .map(function (layer) { return layer.id })
      if (!ids.length) return Promise.resolve()

      var that = this;
      return this.$http.get(this.$store.getters.backendurl + 'api/v1/symbologies?ids=' + ids.join(','))
        .then(function (response) {
          var byLayer = {};
          (response.data || []).forEach(function (item) {
            (byLayer[item.id_layer] = byLayer[item.id_layer] || []).push(item)
          })
          that.$store.commit('symbology/setSymbologies', byLayer)
        })
        .catch(function (error) {
          //Lectura opcional: si falla, el visor queda sin dropdown, no roto.
          console.log('symbologies:', that.symbologyError(error))
        });
    },
  }
}
